import React from 'react';
import styles from './Skeleton.module.scss';
import clsx from 'clsx';

const Skeleton = ({ variant, width, height, className, circle, ...props }) => {
    return (
        <div 
            {...props}
            aria-hidden="true"
            className={clsx(
                styles.skeleton,
                variant && styles[`skeleton--${variant}`],
                circle && styles['skeleton--circle'],
                className
            )}
            style={{ 
                width: width ?? '100%',
                height: height ?? (variant ? undefined : '20px')
            }}
        />
    );
};

export default Skeleton;
